import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c380c32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "disk-left-size download-path-mobile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "下载到盒子", -1))
const _hoisted_3 = { class: "download-path-pc" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "保存到：", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "可用空间：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["download-path", _ctx.disabled || _ctx.lastPath || _ctx.isDiskException ? 'disabled' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("a", {
          class: _normalizeClass(_ctx.belowMinimum ? 'tip' : ''),
          href: "javascript:;"
        }, _toDisplayString(_ctx.diskLeftSize > 0 ? `剩余可用:
            ${_ctx.bytesToSize(_ctx.diskLeftSize)}` : '未知'), 3)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["display-path", _ctx.isDiskException ? 'is-disk-abnormal' : ''])
      }, _toDisplayString(_ctx.shortDownloadPath), 3)
    ]),
    _createElementVNode("i", {
      class: "qh-icon-more download-path-mobile",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showVisiblePathChoose && _ctx.showVisiblePathChoose(...args)))
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.shortDownloadPath), 1),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showVisiblePathChoose && _ctx.showVisiblePathChoose(...args)))
        }, "更改")
      ]),
      (!_ctx.hideSize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.diskSize > 0 ? `${_ctx.bytesToSize(_ctx.diskLeftSize)}/${_ctx.bytesToSize(_ctx.diskSize)}` : '未知'), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}